import { render, staticRenderFns } from "./SuccessStoriesList.vue?vue&type=template&id=df87b5f4&scoped=true"
import script from "./SuccessStoriesList.vue?vue&type=script&lang=js"
export * from "./SuccessStoriesList.vue?vue&type=script&lang=js"
import style0 from "./SuccessStoriesList.vue?vue&type=style&index=0&id=df87b5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df87b5f4",
  null
  
)

export default component.exports